<template>
  <transition name="modal-fade">
    <div
      v-if="show"
      :class="modalClassName"
      transition="modal"
      @mousedown="handleMouseDown"
    >
      <div
        :class="{
          'modal-container rtl:text-right shadow-md overflow-auto relative bg-white dark:bg-slate-800 skip-context-menu': true,
          'rounded-xl w-[37.5rem] max-w-[calc(100vw-2rem)]':
            !fullWidth && size !== 'scroll-preview',
          'items-center rounded-none flex h-full justify-center w-full':
            fullWidth && size !== 'scroll-preview',
          'max-h-[90vh] w-[44.5rem] max-w-[calc(100vw-2rem)]':
            size === 'scroll-preview',
          'max-h-full': size !== 'scroll-preview',
          [size]: true,
        }"
        @mouse.stop
        @mousedown="(event) => event.stopPropagation()"
      >
        <otello-button
          v-if="showCloseButton"
          color-scheme="secondary"
          icon="dismiss"
          variant="clear"
          class="absolute z-10 ltr:right-2 rtl:left-2 top-2"
          @click="close"
        />
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
import {
  addSafeEventListener,
  removeSafeEventListener,
} from 'dashboard/helper/domEvents';

export default {
  props: {
    closeOnBackdropClick: {
      type: Boolean,
      default: true,
    },
    show: Boolean,
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String,
      default: 'centered',
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mousedDownOnBackdrop: false,
    };
  },
  computed: {
    modalClassName() {
      const modalClassNameMap = {
        centered: '',
        'right-aligned': 'right-aligned',
      };

      return `modal-mask skip-context-menu ${
        modalClassNameMap[this.modalType] || ''
      }`;
    },
  },
  mounted() {
    const documentObject = typeof document !== 'undefined' ? document : null;
    addSafeEventListener(documentObject, 'keydown', this.onKeyDown);
    addSafeEventListener(documentObject?.body, 'mouseup', this.onMouseUp);
  },
  beforeUnmount() {
    const documentObject = typeof document !== 'undefined' ? document : null;
    removeSafeEventListener(documentObject, 'keydown', this.onKeyDown);
    removeSafeEventListener(documentObject?.body, 'mouseup', this.onMouseUp);
  },
  methods: {
    onKeyDown(e) {
      if (this.show && e.code === 'Escape') {
        this.onClose();
      }
    },
    handleMouseDown() {
      this.mousedDownOnBackdrop = true;
    },
    close(e) {
      if (e) {
        e.stopPropagation();
      }
      this.onClose();
    },
    onMouseUp() {
      if (this.mousedDownOnBackdrop) {
        this.mousedDownOnBackdrop = false;
        if (this.closeOnBackdropClick) {
          this.onClose();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.modal-mask {
  @apply flex items-center justify-center bg-modal-backdrop-light dark:bg-modal-backdrop-dark z-[9990] h-full left-0 fixed top-0 w-full;
  .modal-container {
    &.medium {
      @apply max-w-[80%] w-[56.25rem];
    }
    // .content-box {
    //   @apply h-auto p-0;
    // }
    .content {
      @apply p-8;
    }
    form,
    .modal-content {
      @apply pt-4 pb-8 px-8 self-center;
      a {
        @apply p-4;
      }
    }
  }
}
.modal-big {
  @apply w-full;
}
.modal-mask.right-aligned {
  @apply justify-end;
  .modal-container {
    @apply rounded-none h-full w-[30rem];
  }
}
.modal-enter,
.modal-leave {
  @apply opacity-0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  transform: scale(1.1);
}
</style>
